
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/page/[page_number]",
      function () {
        return require("private-next-pages/news/page/[page_number].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/page/[page_number]"])
      });
    }
  